module.exports = __webpack_public_path__ + "static/media/02-textpage.1e4073f8.png";